import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { useFormats } from "@portal/hooks/use-formats";
import { RelativeDateRange } from "@portal/util/relative-date-range";
import { dateFormats } from "@sinecycle/growcomponents";
import { useMemo, useState } from "react";
import { FilterFooter } from "../../Footer/FilterFooter";
import { DateRangeInput } from "./DateRangeInput";
import { DateRangeString } from "./type";
import { allDateRangeOptions, getDefaultOptions } from "./utils";

const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export interface DateRangeFilterAdditionalProps {
  format?: string;
  options?: RelativeDateRange[];
}

interface DateRangeFilterProps {
  value: DateRangeString;
  onChange?: (value: DateRangeString) => void;
  additionalProps?: DateRangeFilterAdditionalProps;
  onSubmit: (value: DateRangeString) => void;
  onCancel: () => void;
  showAllRelativeOptions?: boolean;
}

function DateRangeElement(props: DateRangeFilterProps) {
  const {
    value: defaultValue,
    onChange,
    additionalProps,
    onSubmit,
    onCancel,
  } = props;
  const [value, setValue] = useState<DateRangeString>(defaultValue);
  const { dateformat } = useFormats();
  function getOptions() {
    return additionalProps?.options
      ? allDateRangeOptions().filter((option) =>
          additionalProps?.options?.includes(option.id)
        )
      : getDefaultOptions();
  }
  const options = useMemo(getOptions, [additionalProps?.options]);

  function handleChange(value: DateRangeString) {
    setValue(value);
    onChange?.(value);
  }

  function handleSubmit() {
    const modifiedValue: DateRangeString = {
      ...value,
      from: dateFormats.parse(value.from, DEFAULT_DATE_FORMAT),
      to: dateFormats.parse(value.to, DEFAULT_DATE_FORMAT),
    };

    onSubmit?.(modifiedValue);
  }
  const Footer = <FilterFooter onCancel={onCancel} onSubmit={handleSubmit} />;

  function getModifiedValue() {
    return {
      ...value,
      from: dateFormats.parse(value.from, dateformat),
      to: dateFormats.parse(value.to, dateformat),
    };
  }

  const formattedValue = getModifiedValue();

  const DateComp = (
    <DateRangeInput
      value={formattedValue}
      format={dateformat ?? DEFAULT_DATE_FORMAT}
      options={options}
      onChange={handleChange}
    />
  );

  return (
    <Flex vertical>
      {DateComp}
      {Footer}
    </Flex>
  );
}

export { DateRangeElement };
